// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forms .admin-header .logo {
  margin: 15% auto;
  width: 33%;
  top: 20%;
}
.forms .content {
  padding: 0% 8%;
  /*
  .forgot {
      a {
          text-decoration: none;
          text-align: center;
          padding: 8% 0 8%;
          display: block;

          span {
              font: 1.3em/1 vigaregular;
              color: #fff;
              text-decoration: underline;
          }
      }
  }

  .button {
      cursor: pointer;
      a {
          text-decoration: none;
          text-align: center;
          border-radius: 5px;
          padding: 7% 0 7%;
          display: block;
      }

      &.submit {
          background-color: #caa36c;
          border-radius: 5px;
      }

      &.register {
          margin-bottom: 10%;
          a {
              border: 2px solid #caa36c;
          }
      }

      span {
          font: 1.9em/1 vigaregular;
          color: white;
      }
  }

  .login-cta {
      padding: 8% 8% 8% 8%;
      text-align: center;
      h5 {
          font: 1.3em/1 vigaregular;
          color: #fff;
      }
  }

  */
}
.forms .content .form h2 {
  font: 3.3em/1 vigaregular;
  margin: 0% 0% 6% 0%;
  color: #fff;
}
.forms .content .form .error {
  font: 1.2em/1 vigaregular;
  color: #fff;
  padding-top: 2%;
  padding-bottom: 2%;
}
.forms .content .form input,
.forms .content .form select {
  width: 100%;
  border-radius: 6px;
  outline: none;
  padding: 7% 5%;
  /*padding: 7% 0% 7% 5%;*/
  border: 0;
  box-sizing: border-box;
  font: 1.4em/1 vigaregular;
  color: #be9a68;
}
.forms .content .form input::placeholder,
.forms .content .form select::placeholder {
  color: #be9a68;
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/Forms.scss"],"names":[],"mappings":"AAEQ;EACI,gBAAA;EACA,UAAA;EACA,QAAA;AADZ;AAKI;EACI,cAAA;EAkCA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAAA;AAiBR;AAhDY;EACI,yBAAA;EACA,mBAAA;EACA,WAAA;AAkDhB;AA/CY;EACI,yBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAiDhB;AA9CY;;EAEI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,wBAAA;EACA,SAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AAgDhB;AA9CgB;;EACI,cAAA;EACA,YAAA;AAiDpB","sourcesContent":[".forms {\n    .admin-header {\n        .logo {\n            margin: 15% auto;\n            width: 33%;\n            top: 20%;\n        }\n    }\n\n    .content {\n        padding: 0% 8%;\n\n        .form {\n            h2 {\n                font: 3.3em/1 vigaregular;\n                margin: 0% 0% 6% 0%;\n                color: #fff;\n            }\n\n            .error {\n                font: 1.2em/1 vigaregular;\n                color: #fff;\n                padding-top: 2%;\n                padding-bottom: 2%;\n            }\n\n            input,\n            select {\n                width: 100%;\n                border-radius: 6px;\n                outline: none;\n                padding: 7% 5%;\n                /*padding: 7% 0% 7% 5%;*/\n                border: 0;\n                box-sizing: border-box;\n                font: 1.4em/1 vigaregular;\n                color: #be9a68;\n\n                &::placeholder {\n                    color: #be9a68;\n                    opacity: 0.5;\n                }\n            }\n        }\n        /*\n        .forgot {\n            a {\n                text-decoration: none;\n                text-align: center;\n                padding: 8% 0 8%;\n                display: block;\n\n                span {\n                    font: 1.3em/1 vigaregular;\n                    color: #fff;\n                    text-decoration: underline;\n                }\n            }\n        }\n        \n        .button {\n            cursor: pointer;\n            a {\n                text-decoration: none;\n                text-align: center;\n                border-radius: 5px;\n                padding: 7% 0 7%;\n                display: block;\n            }\n\n            &.submit {\n                background-color: #caa36c;\n                border-radius: 5px;\n            }\n\n            &.register {\n                margin-bottom: 10%;\n                a {\n                    border: 2px solid #caa36c;\n                }\n            }\n\n            span {\n                font: 1.9em/1 vigaregular;\n                color: white;\n            }\n        }\n\n        .login-cta {\n            padding: 8% 8% 8% 8%;\n            text-align: center;\n            h5 {\n                font: 1.3em/1 vigaregular;\n                color: #fff;\n            }\n        }\n\n        */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
